var map = {
	"./airdrop.js": 34040,
	"./assets.js": 76956,
	"./autobot.js": 24129,
	"./daily.js": 9052,
	"./lottery.js": 13140,
	"./lucky.js": 97457,
	"./mine.js": 96954,
	"./ranking.js": 50331,
	"./squad.js": 97091,
	"./task.js": 55092,
	"./user.js": 65798,
	"./wallet.js": 44664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46453;